/**
 * Created by zhengyf on 2018/5/10.
 */

;(function () {

    UploaderService.$inject = ['request', '$q', '$timeout', 'progressService', 'UploaderConfig'];
    angular
        .module('app.core')
        .directive('fileUpload', fileChangeDirective)
        .service('progressService', progressService)
        .factory('UploaderService', UploaderService);

    function UploaderService(request, $q, $timeout, progressService, UploaderConfig) {

        function Uploader() {
            this.progressChangeCB = null;
            this.list = [];
            this.uploadingList = [];
            this.waitList = [];
            this.MAX_UPLOAD_NUM = 1;
            this.cancelers = {};
        }

        /**
         * 开始上传
         * @param file {object} 准备上传的文件
         * @param pageFileInfo {object} 页面中用到的文件相关信息
         * @param progressChangeCB {func} 上传进度的回调函数
         * @param options {object} {max: 最大同时上传数量}
         * @returns {Promise}
         */
        Uploader.prototype.start = function (file, pageFileInfo, progressChangeCB, options) {
            var
                deferred = $q.defer(),
                id = getGUID(),
                fileInfo
            ;
            options = options || {};
            pageFileInfo = pageFileInfo || {};
            pageFileInfo.id = id;
            fileInfo = {
                id: id,
                pageFileInfo: DSSX.util.extend(pageFileInfo, generateDefaultPageFileInfo(file)),
                file: file,
                pending: deferred
            };

            this.MAX_UPLOAD_NUM = options.max || 1;
            this.progressChangeCB = progressChangeCB;
            this.list.push(fileInfo);
            this.waitList.push(fileInfo);

            if (this.getUploadNum() >= 1) {
                this.beginUpload();
            }

            return deferred.promise;
        };

        // 检查剩余上传数
        Uploader.prototype.getUploadNum = function () {
            return this.MAX_UPLOAD_NUM - this.uploadingList.length;
        };

        // 开始一个上传
        Uploader.prototype.beginUpload = function () {
            var count = this.getUploadNum();
            while (this.waitList.length && count > 0) {
                this.uploadNext();
                count = this.getUploadNum();
            }
        };

        Uploader.prototype.uploadNext = function () {
            var info = this.waitList.shift();
            if (!info) {
                console.warn('[FileUploaderFactory::Uploader] uploadNext: cannot found next file');
                return;
            }

            this.uploadingList.push(info);

            // 修改状态为上传中
            modifyFileUploadStatus(this.list, info.id);

            // 开始上传
            var that = this;

            var option = UploaderConfig.getConfig();

            option.onProgress = function (f, e) {
                info.pageFileInfo.status = 'uploading';
                $timeout(function () {
                    progressService.onProgress(e, that.list, info, that.progressChangeCB);
                });
            };
            option.onSuccess = function (f, data) {
                uploadSuc(data);
                delete that.cancelers[info.id];
            };
            option.onError = function (f, data) {
                uploadErr(data);
                delete that.cancelers[info.id];
            };
            // option.onAbort = function (f, data) {
            //     // TODO:BUG:upload.abort
            //     // TODO: 如果没有问题，更新至其他 UploaderService 代码... 啊啊啊.
            //     // 多重因素导致的 bug
            //     // `common/upload.js` ， abort 后，不触发错误回调和成功回调，而是触发 onAbort 回调
            //     //   common/upload 若在请求任意接口前，被 abort ，触发的是 onAbort 回调
            //     //   若有请求任意接口，被 abort，触发的是 onError or onSuccess 回调。。。(有这个问题，不确定是否全是)
            //     //       确认的 bug: 后续请求的 fileStatus 接口 ,根本不会被 abort !!, 仍在继续, 但不会触发任何回调
            //     //       到达 multiPartUpload 接口时再 abort , 会触发 error 回答
            //     // 所以， 没有进入到 suc or err 流程, 没有调用 handUploadList 函数，没有把该文件从 uploadingList 移除
            //     //   导致下次上传文件时， getUploadNum() 一直为 0 ，新文件停留在 waitList ，没有上传
            //     // PS: 修复方案，这里，直接触发原有的 错误回调
            //     //
            //     // 我错了...，
            //     // `common/upload.js`,使用 `(new uploadFactory).abort()` 调用成功，居然不会触发 onAbort 回调。。
            //     // PS: 修复方案：在调用 abort() 后, 直接在这里调用 uploadErr() , 来达到 外部调用者 abort 后
            //     //   , 后续进入 error 流程, 从 waitList 移掉, 并保证外部调用者后续能触发相应的页面错误处理, 而不是没有任何反应
            //
            //     // uploadErr(data);
            // };

            var uploadTmp = new uploadFactory(option);
            uploadTmp.add([info.file]);
            // 中止事件
            var deferTmp = $q.defer();
            this.cancelers[info.id] = deferTmp;
            deferTmp.promise.then(function () {
                uploadTmp.abort(info.file);

                uploadErr(); // bug fix, 见 TODO:BUG:upload.abort
            });

            // var uploadDeferred = this.upload(info);
            // uploadDeferred.then(uploadSuc, uploadErr);

            function uploadSuc(res) {
                handUploadList();
                res.id = info.id;
                info.pending.resolve(res);
            }

            function uploadErr(err) {
                handUploadList();
                info.pending.reject(err);
            }

            function handUploadList() {
                var
                    uploadingList = that.uploadingList,
                    idx = uploadingList.indexOf(info)
                ;

                info.pageFileInfo && (info.pageFileInfo.status = 'completed');

                if (idx > -1) {
                    uploadingList.splice(idx, 1);
                }

                $timeout(function () {
                    that.beginUpload();
                });
            }

            function modifyFileUploadStatus(files, id) {
                for (var i = 0; i < files.length; i++) {

                    if (files[i].id === id) {
                        files[i].pageFileInfo.status = 'uploading';
                    }
                }
            }
        };

        // Uploader.prototype.upload = function (info) {
        //     var
        //         that = this,
        //         canceler = $q.defer(),
        //         fd = new FormData(),
        //         arg_filter = {
        //             transformRequest: angular.identity,
        //             headers: {'Content-Type': undefined},
        //             uploadEventHandlers: { // 上传的时候触发
        //                 progress: function (e) {
        //                     if (e.lengthComputable) {
        //                         progressService.onProgress(e, that.list, info, that.progressChangeCB);
        //                     }
        //                 }
        //             },
        //             timeout: canceler.promise,
        //         }
        //     ;
        //
        //     fd.append('file', info.file);
        //     that.cancelers[info.id] = canceler;
        //
        //     return request.post(getUploadUrl(), {}, fd, true, arg_filter)
        //         .then(callback, errCallback)
        //         .finally(function () {
        //             delete that.cancelers[info.id];
        //         });
        //
        //     function callback(res) {
        //         return res;
        //     }
        //
        //     function errCallback(error) {
        //         return $q.reject(error);
        //     }
        //
        // }

        Uploader.prototype.cancel = function (id) {
            if (!id) {
                console.warn('[UploaderService::Uploader] cancel: id is not exist');
                return;
            }

            var
                that = this,
                c = that.cancelers[id]
            ;

            if (c) {
                c.resolve();
                delete that.cancelers[id];
            } else {
                // 取消在等待队列中的文件
                for (var i = 0; i < this.waitList.length; i++) {
                    if (this.waitList[i].id === id) {
                        this.waitList.splice(i, 1);
                        break;
                    }
                }
            }

        }


        function getGUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var
                    d = new Date().getTime(),
                    r = (d + Math.random() * 16) % 16 | 0
                ;
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
        }

        // 根据传进的 file 对象生成默认 pageFileInfo
        // 修复旧逻辑没有设置默认值，导致缺省时 progressService 直接读取 pageFileInfo.progress 报错问题
        function generateDefaultPageFileInfo(file) {
            return {
                name: file.name || '',
                status: 'beUpload',
                progress: {
                    totalSize: file.size,
                    loadedSize: 0
                },
            }
        }

        return new Uploader();

    }

    function fileChangeDirective() {
        return {
            restrict: "A",
            scope: {
                fileUpload: '&'
            },
            link: function (scope, element) {
                var slice = Array.prototype.slice;
                element.on("change.fileChangeDirective", function () {
                    scope.$apply(function () {
                        scope.fileUpload({
                            $event: {
                                files: slice.call(element[0].files)
                            }
                        });
                        element[0].value = '';
                    });
                });
            }
        }
    }

    function progressService() {
        this.onProgress = onProgress;

        function onProgress(e, files, info, progressChangeCB) {

            if (typeof progressChangeCB !== 'function') {
                return
            }

            //单个图片的上传进度条
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                if (files[i].id === info.id) {
                    file.pageFileInfo.progress.loadedSize = e.loaded;
                    try {
                        progressChangeCB(file.pageFileInfo);
                    }catch (e) {
                        console.error('[uploader-contact.service.js] onProgress callback error', e)
                    }
                    break;
                }
            }
        }
    }

})();
